module.exports = __webpack_public_path__ + "img/20200501_160645.c8882b82.jpg";